<template>
  <div class="new-item hit-cursor" @click="handleClick">
    <div class="image-box">
<!--      <img :src="news.image" alt="新闻缩略图" />-->
      <el-image :src="news.image" fit="cover" class="banner-image"></el-image>
    </div>
    <div class="right-inner">
      <div class="right-inner-title">{{ news.title }}</div>
      <div class="right-inner-desc">
        <div v-html="news.desc"></div>
      </div>
      <div class="right-inner-tags">
        <div>
          <span class="tag-author">{{ news.author }}</span>
          <span class="tag">{{ news.cate.cate_name }}</span>
        </div>
        <span class="tag-item">{{ news.created_at }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "new-item",
  props: {
    news: {
      type: Object,
      default: {},
    },
  },
  mounted() {
    console.log(this.news);
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: "/ruitian-news/news-detail",
        query: {
          id: this.news.id,
        },
      });
    },
  },
};
</script>
  <style lang="scss" scoped>
.new-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 0 20px;
  border-bottom: 1px solid #d1d5e3;
  .image-box {
    width: 150px;
    height:150px;
    background: #d1d5e3;
    border-radius: 6px 6px 6px 6px;
    img {
      width: 100%;
      height: 100%;
    }
    .banner-image {
      width: 100%;
      height: 100%;
    }
  }
  .right-inner {
    width: 590px;
    flex: 1;
    margin-left: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .right-inner-title {
      font-weight: bold;
      font-size: 18px;
      color: #00112b;
      line-height: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .right-inner-desc {
      font-weight: 400;
      font-size: 16px;
      color: #5f616c;
      display: -webkit-box; /* 使用WebKit的盒子模型 */
      -webkit-line-clamp: 3; /* 限制显示两行 */
      -webkit-box-orient: vertical; /* 设置盒子方向为垂直 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */

    }
    .right-inner-tags {
      display: flex;
      justify-content: space-between;
      padding: 10px 0 10px;
      align-items: center;
      .tag-author {
        font-weight: 400;
        font-size: 16px;
        color: #00112b;
      }
      .tag {
        display: inline-block;
        margin-left: 18px;
        line-height: 30px;
        padding: 0 10px;
        height: 30px;
        background: #ffffff;
        border-radius: 15px 15px 15px 15px;
        border: 1px solid #afafaf;
        font-weight: 400;
        font-size: var(--font-size-default-14);
        color: #afafaf;
      }
      .tag-item {
        font-weight: 400;
        font-size: var(--font-size-default-14);
        color: #00112b;
      }
    }
  }
}
</style>